import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import Icon from '@material-ui/core/Icon';
import Paper from '@material-ui/core/Paper';
import React, { useState, useCallback } from 'react';
import { toast } from 'react-toastify';
import { useCallbackObservable, useObservable } from 'react-use-observable';
import { of } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import AddPaymentMethodDialog from 'v2/components/Shared/AddPaymentMethodDialog';
import ListCards from 'v2/components/Shared/SelectCreditCard/ListCards';
import { customerFactory } from 'v2/services/customer';

import type { ICard } from 'v2/components/Shared/SelectCreditCard';

import { useStyles } from './styles';

import type { FormikProps } from 'formik';

const PaymentMethods = () => {
  const classes = useStyles();
  const [isAddCardDialogOpen, setIsAddCardDialongOpen] = useState(false);
  useObservable(() => customerFactory.loadCardsList(), []);
  const [cardsList] = useObservable(() => customerFactory.getCardsList(), []);
  const [cardUsage] = useObservable(() => customerFactory.getCardUsage(), [], []);
  const [isLoadingCards] = useObservable(() => customerFactory.loadingCards(), []);
  const [isLoadingCardsUsage] = useObservable(() => customerFactory.loadingCardUsage(), []);
  const [getCardUsage] = useCallbackObservable((cardId) => customerFactory.loadCardUsage(cardId), []);
  const [cleanCardUsage] = useCallbackObservable(() => customerFactory.cleanCardUsage(), []);

  const handleOpenAddCardDialog = () => {
    setIsAddCardDialongOpen(true);
  };

  const handleCloseAddCardDialog = useCallback(() => {
    setIsAddCardDialongOpen(false);
  }, []);

  const [onSubmit] = useCallbackObservable((values: ICard, { setSubmitting, resetForm }: FormikProps<ICard>) => {
    setSubmitting(true);
    return customerFactory.saveNewCard(values).pipe(
      tap(() => {
        setSubmitting(false);
        handleCloseAddCardDialog();
        resetForm();
        toast.success('Forma de pagamento cadastrada com sucesso!');
      }),
      catchError((err) => {
        setSubmitting(false);
        toast.error(err);
        return of(true);
      })
    );
  }, []);

  return (
    <Grid container direction='column'>
      <Grid container justify='space-between' alignItems='flex-start'>
        <div className='my-title'>
          <h1>Minhas Formas de Pagamento</h1>
          <p>Configure suas formas de pagamento.</p>
        </div>

        <Button variant='contained' color='secondary' onClick={handleOpenAddCardDialog} id='add-new-payment-method-button'>
          <Icon style={{ marginRight: '0.5rem', fontSize: 15 }}>add</Icon> Adicionar Forma de Pagamento
        </Button>
      </Grid>

      <div className='m24'></div>

      <Paper elevation={0} className={classes.cards}>
        <ListCards
          cardsList={cardsList}
          isLoadingCards={isLoadingCards}
          isLoadingCardUsage={isLoadingCardsUsage}
          cardUsage={cardUsage}
          cleanCardUsage={cleanCardUsage}
          getCardUsage={getCardUsage}
        />
      </Paper>

      <AddPaymentMethodDialog isOpen={isAddCardDialogOpen} onClose={handleCloseAddCardDialog} onSubmit={onSubmit} />
    </Grid>
  );
};

export default PaymentMethods;
